// extracted by mini-css-extract-plugin
module.exports = {"centerContainer":"BlogHero-module--centerContainer--3FNRi","title":"BlogHero-module--title--3ojme"};